import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_wrong",
  "use": "icon-icon_wrong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_wrong\"><defs><style></style></defs><path d=\"M548.25 512l309.452-309.658a25.6 25.6 0 1 0-36.25-36.25L512 475.75 202.342 166.298a25.6 25.6 0 0 0-36.044 36.044L475.75 512 166.298 821.658a25.6 25.6 0 1 0 36.25 36.25L512 548.25l309.658 309.452a25.6 25.6 0 0 0 36.25-36.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol